export const messages = {
  en: {
    printPayFeeXiangyun: {
      applyForm: 'Application Form',
      receiptForm: 'Receipt Form',
      receiptNum: 'Receipt No.',
      payTime: 'Payment Time',
      owner: 'Owner',
      serialNumber: 'No.',
      feeItem: 'Fee Item',
      houseCar: 'House/Car',
      feeRange: 'Fee Range',
      cycle: 'Cycle',
      unitPriceFixed: 'Unit Price/Fixed Fee',
      areaUsage: 'Area/Usage',
      paymentMethod: 'Payment Method',
      amount: 'Amount',
      discountAmount: 'Discount Amount',
      remark: 'Remark',
      to: ' to ',
      none: 'None',
      capitalRMB: 'Capital RMB',
      departmentHead: 'Department Head',
      operator: 'Operator',
      financeReceipt: 'Finance Receipt',
      customerConfirm: 'Customer Confirm'
    }
  },
  zh: {
    printPayFeeXiangyun: {
      applyForm: '申请单',
      receiptForm: '收据单',
      receiptNum: '单号',
      payTime: '缴费时间',
      owner: '业主',
      serialNumber: '编号',
      feeItem: '收费项目',
      houseCar: '房屋/车辆',
      feeRange: '收费范围',
      cycle: '周期',
      unitPriceFixed: '单价/固定费',
      areaUsage: '面积/用量',
      paymentMethod: '支付方式',
      amount: '金额',
      discountAmount: '优惠金额',
      remark: '备注',
      to: '至',
      none: '无',
      capitalRMB: '大写人民币',
      departmentHead: '部门负责人',
      operator: '经办人',
      financeReceipt: '财务收款',
      customerConfirm: '客户确认'
    }
  }
}

